import { useSelector } from 'react-redux';
import { selectUserId } from '@store/global/selectors';
import { ApiError } from '@features/advanced-errors/types/ApiError';



interface ApiErrorElementProps {
	error: ApiError
};


const ApiErrorElement = (props: ApiErrorElementProps) => {
	const { timestamp, actionPayload, meta, request } = props.error;
	
	const userId = useSelector(selectUserId);

	return (
		<div className="error-element">	

			<p>Api Error</p>
			
			<p>{`error - ${actionPayload ? actionPayload.error : '-'}`}</p>
			<p>{`status - ${actionPayload ? actionPayload.status : '-'}`}</p>
			
			<p>{`endpoint - ${meta ? meta.endpoint : '-'}`}</p>
			<p>{`args - ${meta ? JSON.stringify(meta.originalArgs) : '-'}`}</p>
			
			<p>{`method - ${request ? request.method : '-'}`}</p>
			<p>{`url - ${request ? request.url : '-'}`}</p>
			
			<p>{`user - ${userId}`}</p>
			<p>{`time - ${timestamp}`}</p>
		</div>
	)
};

export default ApiErrorElement;